import QuantitySelector from '../inputs/quantity-selector';
import PageHelper from '../../helpers/page-helper';

export default class CartQuantitySelector extends QuantitySelector {

  static readonly QUANTITY_SELECTOR_SELECTOR = '.js-updateCartEntry';
  static readonly QUANTITY_INPUT_SELECTOR = '.js-qty-selector-input';
  static readonly SIDEBAR_SELECTOR = '.js-sidebar';
  private timeout;
  private readonly timeoutLength: number = 400;
  protected readonly input: JQuery;

  constructor(container: JQuery) {
    super(container);
    this.input = this.container.find(CartQuantitySelector.QUANTITY_INPUT_SELECTOR);
    this.bindChange();
    this.bindSubmit();
  }

  static initAll(): void {
    $(CartQuantitySelector.QUANTITY_SELECTOR_SELECTOR).map((i, el) => new CartQuantitySelector($(el)));
  }

  bindSubmit(): void {
    this.input.on('keypress', (e) => {
      if (e.which === 13) {
        this.submitChangedQuantity();
      }
    });
  }

  bindChange(): void {
    this.input.on('change', () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.submitChangedQuantity(), this.timeoutLength);
    });
  }

  updateCart(): JQuery.jqXHR {
    const { location } = window;
    const entryNumber = this.input.data('entry-number') as string;
    const quantity = this.input.val() as number;
    const { CSRFToken } = window.ACC.config;
    const url = `${location.href}/update?entryNumber=${entryNumber}&quantity=${quantity}`;

    return $.ajax({
      url,
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: {
        CSRFToken,
      },
    });
  }

  submitChangedQuantity(): void {
    PageHelper.showLoadingIndicator();
    this.updateCart()
      .then(() => {
        $(CartQuantitySelector.QUANTITY_SELECTOR_SELECTOR).addClass('-disabled');
        window.location.reload();
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }
}
